import { LILITH_FOCUS_MODES } from '../focus-modes/lilith-focus.js';
import { RELATIONSHIP_FOCUS_MODES } from '../focus-modes/relationship-focus.js';
import { SHADOW_FOCUS_MODES } from '../focus-modes/shadow-focus.js';
import { YEARLY_FOCUS_MODES } from '../focus-modes/yearly-focus.js';
import { ALL_SPREAD_DEFINITIONS } from './all-spreads.js';
const ALL_FOCUS_MODES = [
    ...LILITH_FOCUS_MODES,
    ...RELATIONSHIP_FOCUS_MODES,
    ...YEARLY_FOCUS_MODES,
    ...SHADOW_FOCUS_MODES,
];
export const SPREAD_DEFINITION_BY_SLUG = Object.fromEntries(ALL_SPREAD_DEFINITIONS.map((definition) => [definition.spread.slug, definition]));
export const SPREAD_DEFINITION_BY_ID = Object.fromEntries(ALL_SPREAD_DEFINITIONS.map((definition) => [definition.spread.id, definition]));
export const FOCUS_MODE_BY_ID = Object.fromEntries(ALL_FOCUS_MODES.map((mode) => [mode.id, mode]));
export const getSpreadDefinitionBySlug = (slug) => SPREAD_DEFINITION_BY_SLUG[slug];
export const getSpreadDefinitionById = (id) => SPREAD_DEFINITION_BY_ID[id];
export const getSpreadBySlug = (slug) => SPREAD_DEFINITION_BY_SLUG[slug]?.spread;
export const getSpreadById = (id) => SPREAD_DEFINITION_BY_ID[id]?.spread;
export const getFocusModeById = (id) => FOCUS_MODE_BY_ID[id];
export const getFocusModesForSpread = (slug) => ALL_FOCUS_MODES.filter((mode) => mode.spread_slug === slug);
//# sourceMappingURL=slugs.js.map